/* KALMA — carrito blindado. Este funnel SOLO toca su propio producto. */
(function(){
  function init(){
    var KAL_PID=0, sel=0;
    function root(){return document.getElementById('kal');}
    function sync(){
      var r=root();
      if(!r)return false;
      if(!KAL_PID)KAL_PID=parseInt(r.dataset.pid,10);
      if(!sel){
        var on=document.querySelector('#kal .pk.on');
        sel=parseInt(on?on.dataset.vid:r.dataset.defvid,10);
      }
      return true;
    }

    /* Borra del carrito CUALQUIER item que no sea Kalma: protege a los demas funnels */
    function kalLimpia(){
      return fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(c){
        var ajenos=c.items.filter(function(it){return it.product_id!==KAL_PID;});
        if(!ajenos.length)return;
        var u={};ajenos.forEach(function(it){u[it.key]=0;});
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})});
      }).catch(function(){});
    }
    /* Los packs son alternativas entre si: al elegir uno se quitan los otros */
    function kalQuitaPacks(){
      return fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(c){
        var mios=c.items.filter(function(it){return it.product_id===KAL_PID;});
        if(!mios.length)return;
        var u={};mios.forEach(function(it){u[it.key]=0;});
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})});
      }).catch(function(){});
    }

    function money(c){return '$'+(c/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2});}
    function render(c){
      var h='';
      c.items.forEach(function(it){
        h+='<div class="it"><img src="'+(it.image||'')+'" alt=""><div class="t">'+it.product_title+
           '<br><span style="color:#6b6560">'+it.variant_title+' &middot; '+money(it.final_line_price)+'</span></div>'+
           '<button class="x" data-k="'+it.key+'">Quitar</button></div>';
      });
      if(!c.items.length)h='<p style="color:#6b6560;font-size:13px;padding:10px 0">Tu carrito esta vacio.</p>';
      var box=document.getElementById('kalItems');
      box.innerHTML=h;
      document.getElementById('kalTot').textContent=money(c.total_price);
      box.querySelectorAll('.x').forEach(function(b){
        b.addEventListener('click',function(){
          var u={};u[b.dataset.k]=0;
          fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})})
            .then(function(r){return r.json();}).then(render);
        });
      });
    }
    function open_(){
      fetch('/cart.js',{cache:'reload'}).then(function(r){return r.json();}).then(render);
      document.getElementById('kalOv').style.display='flex';
    }
    function close_(){document.getElementById('kalOv').style.display='none';}

    function buy(){
      if(!sync()||!sel)return;
      var btns=document.querySelectorAll('#kal .cta,#kalBar button');
      btns.forEach(function(b){if(!b.dataset.t)b.dataset.t=b.textContent;b.textContent='Agregando…';b.disabled=true;});
      function done(){btns.forEach(function(b){b.textContent=b.dataset.t;b.disabled=false;});}
      kalLimpia()
       .then(kalQuitaPacks)
       .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:sel,quantity:1}]})});})
       .then(function(r){if(!r.ok)throw 0;return r.json();})
       .then(function(){done();open_();})
       .catch(function(){done();window.location.href='/cart/'+sel+':1';});
    }

    /* Delegacion en document: funciona aunque el script cargue antes que el HTML */
    document.addEventListener('click',function(e){
      var t=e.target;
      if(t.closest('#kal .cta[data-buy]')||t.closest('#kalBar button')){buy();return;}
      if(t.closest('#kal .cta[data-scroll]')){
        var f=document.querySelector('#kal .pk');
        if(f)f.scrollIntoView({behavior:'smooth'});
        return;
      }
      if(t.closest('#kalDr .cerrar')){close_();return;}
      if(t.id==='kalOv'){close_();return;}
      var card=t.closest('#kal .pk');
      if(card){
        sync();
        document.querySelectorAll('#kal .pk').forEach(function(c){c.classList.remove('on');});
        card.classList.add('on');
        sel=parseInt(card.dataset.vid,10);
        var bp=document.getElementById('kalBarP');
        if(bp)bp.textContent=card.dataset.price;
      }
    });

    window.addEventListener('pageshow',function(){
      document.querySelectorAll('#kal .cta,#kalBar button').forEach(function(b){
        if(b.dataset.t){b.textContent=b.dataset.t;b.disabled=false;}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
